import { useCallback } from 'react';

import { Params, useGetMessages } from '@web/conversations/hooks/useGetMessages';
import {
  useConversationActions,
  useConversationState,
} from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';

export const useGetMessagesAction = () => {
  const { insertMessages } = useConversationActions();
  const { id, selectedMessageId } = useConversationState();

  const query = useGetMessages({
    conversationId: id,
    selectedMessageId,
  });

  const { fetchNextPage: originalFetchNextPage, fetchPreviousPage: originalFetchPreviousPage } =
    query;

  // fetch newer messages
  const fetchPreviousPage = useCallback(async () => {
    const query = await originalFetchPreviousPage();

    const firstIndex = 0;
    const messages = query.data.pages[firstIndex];
    const afterId = (query.data.pageParams[firstIndex] as Params).afterId;

    insertMessages({
      afterId,
      messages,
    });
  }, [originalFetchPreviousPage, insertMessages]);

  // fetch older messages
  const fetchNextPage = useCallback(async () => {
    const query = await originalFetchNextPage();

    const lastIndex = query.data.pages.length - 1;
    const messages = query.data.pages[lastIndex];
    const beforeId = (query.data.pageParams[lastIndex] as Params).beforeId;

    insertMessages({
      beforeId,
      messages,
    });
  }, [originalFetchNextPage, insertMessages]);

  return {
    fetchPreviousPage,
    fetchNextPage,
    query,
  };
};
